/* Order source tracking: first/last touch -> cart attributes (shown on the order in admin).
   Stores marketing/source params only, no personal data. */
(function () {
  'use strict';
  var KEY = 'ps_attr', DAY = 864e5, CLICK_IDS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid', 'ttclid', 'li_fat_id', 'epik', '_kx'];
  var PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id', 'gad_source', 'gad_campaignid', 'srsltid'].concat(CLICK_IDS);
  var AI = [
    ['ChatGPT', /(^|\.)(chatgpt\.com|chat\.openai\.com)$/, /chatgpt|openai/],
    ['Perplexity', /(^|\.)perplexity\.ai$/, /perplexity/],
    ['Gemini', /^(gemini|bard)\.google\.com$/, /gemini|bard/],
    ['Microsoft Copilot', /^copilot\.microsoft\.com$/, /copilot/],
    ['Claude', /^claude\.ai$/, /claude/],
    ['Meta AI', /(^|\.)meta\.ai$/, /meta\.ai|metaai/],
    ['DeepSeek', /^chat\.deepseek\.com$/, /deepseek/],
    ['Grok', /(^|\.)(grok\.com|x\.ai)$/, /grok/],
    ['You.com', /(^|\.)you\.com$/, /you\.com/],
    ['Phind', /(^|\.)phind\.com$/, /phind/],
    ['Mistral Le Chat', /^chat\.mistral\.ai$/, /mistral/]
  ];
  var OTHER_SEARCH = [['DuckDuckGo', /duckduckgo\./], ['Yahoo', /(^|\.)yahoo\./], ['Ecosia', /ecosia\./]];

  function store(type) { try { return window[type]; } catch (e) { return null; } }
  function get(s, k) { try { return s && s.getItem(k); } catch (e) { return null; } }
  function set(s, k, v) { try { s && s.setItem(k, v); } catch (e) {} }
  var ls = store('localStorage'), ss = store('sessionStorage');

  function hostOf(url) { try { return new URL(url).hostname.toLowerCase().replace(/^www\./, ''); } catch (e) { return ''; } }
  function internal(h) {
    var self = location.hostname.replace(/^www\./, '');
    return !h || h === self || /(^|\.)(myshopify\.com|shopify\.com|shop\.app)$/.test(h) || h === hostOf('https://' + ((window.Shopify && Shopify.shop) || ''));
  }

  // Rules table: first match wins. t = touch {p: params, ref: referrer host, refUrl}.
  function classify(t) {
    var p = t.p, h = t.ref, src = (p.utm_source || '').toLowerCase(), med = (p.utm_medium || '').toLowerCase();
    var paid = /cpc|ppc|paid|ads?$|display|cpm/.test(med), i;
    for (i = 0; i < AI.length; i++) {
      if ((h && AI[i][1].test(h)) || (src && AI[i][2].test(src))) return { ch: 'AI Assistant - ' + AI[i][0], ai: AI[i][0] };
    }
    if (h === 'bing.com' && /bing\.com\/chat/.test(t.refUrl || '')) return { ch: 'AI Assistant - Microsoft Copilot', ai: 'Microsoft Copilot' };
    if (p.gclid || p.gbraid || p.wbraid || p.gad_source || (paid && /google/.test(src || h))) return { ch: 'Google Ads' };
    if (p.srsltid || (/google/.test(src) && med === 'organic_shopping')) return { ch: 'Google Shopping (free listings)' };
    if (p.msclkid || (paid && /bing|microsoft/.test(src || h))) return { ch: 'Bing Ads' };
    if ((p.fbclid && paid) || (paid && /facebook|instagram|^fb$|^ig$|meta/.test(src))) return { ch: 'Meta Ads' };
    if (p.ttclid || /tiktok/.test(src || h)) return { ch: p.ttclid || paid ? 'TikTok Ads' : 'TikTok' };
    if (p.li_fat_id) return { ch: 'LinkedIn Ads' };
    if (p.epik) return { ch: 'Pinterest Ads' };
    if (med === 'email' || p._kx || /klaviyo/.test(src)) return { ch: 'Email (Klaviyo)' };
    if (/instagram/.test(src || h)) return { ch: 'Instagram Organic' };
    if (p.fbclid || /facebook|^fb$/.test(src) || /(^|\.)facebook\.com$/.test(h)) return { ch: 'Facebook Organic' };
    if (/^google\.[a-z.]+$/.test(h) && !src) return { ch: 'Google Organic' };
    if (h === 'bing.com' && !src) return { ch: 'Bing Organic' };
    for (i = 0; i < OTHER_SEARCH.length; i++) if (OTHER_SEARCH[i][1].test(h)) return { ch: 'Organic Search - ' + OTHER_SEARCH[i][0] };
    if (src) return { ch: 'Campaign - ' + src + (med ? ' / ' + med : '') };
    if (h) return { ch: 'Referral - ' + h };
    return { ch: 'Direct' };
  }

  function marketingDenied() {
    try { var cp = window.Shopify && Shopify.customerPrivacy; return !!(cp && cp.marketingAllowed && cp.marketingAllowed() === false); } catch (e) { return false; }
  }
  function scrub(t) { if (t && marketingDenied()) CLICK_IDS.forEach(function (k) { delete t.p[k]; }); return t; }

  // Build this page view's touch.
  var qs = new URLSearchParams(location.search), p = {}, hasParams = false;
  PARAMS.forEach(function (k) { var v = qs.get(k); if (v) { p[k] = v.slice(0, 100); hasParams = true; } });
  var refHost = hostOf(document.referrer), external = !!refHost && !internal(refHost);
  var refUrl = '';
  if (external) { try { var r = new URL(document.referrer); refUrl = (r.origin + r.pathname).slice(0, 200); } catch (e) {} }
  var now = Date.now();
  var touch = { p: p, ref: external ? refHost : '', refUrl: refUrl, land: location.pathname.slice(0, 200), ts: now };
  touch.c = classify(touch);

  var data;
  try { data = JSON.parse(get(ls, KEY) || 'null'); } catch (e) { data = null; }
  if (!data || !data.first || now - data.first.ts > 90 * DAY) data = { first: touch, last: touch, visits: 0 };
  else if (hasParams || external) data.last = touch;
  if (!get(ss, KEY + '_v')) { data.visits = (data.visits || 0) + 1; set(ss, KEY + '_v', '1'); }
  scrub(data.first); scrub(data.last);
  set(ls, KEY, JSON.stringify(data));

  function cut(v) { return String(v || '').slice(0, 250); }
  function label(t) { var s = t.p.utm_source, m = t.p.utm_medium; return t.c.ch + (s && t.c.ch.indexOf(s) < 0 ? ' (' + s + (m ? ' / ' + m : '') + ')' : ''); }
  function attrs() {
    var f = data.first, l = data.last, lp = l.p, gid = [], other = [];
    ['gclid', 'gbraid', 'wbraid', 'gad_source', 'gad_campaignid'].forEach(function (k) { if (lp[k]) gid.push(k + ':' + lp[k]); });
    ['fbclid', 'msclkid', 'ttclid', 'li_fat_id', 'epik', 'srsltid'].forEach(function (k) { if (lp[k]) other.push(k + ':' + lp[k]); });
    return {
      'Source - First Touch': cut(label(f)),
      'Source - Last Touch': cut(label(l)),
      'AI Assistant': cut(l.c.ai || f.c.ai),
      'UTM Campaign': cut(lp.utm_campaign || f.p.utm_campaign),
      'UTM Term': cut(lp.utm_term || f.p.utm_term),
      'Landing Page': cut(l.land),
      'Referrer': cut(l.refUrl),
      'Google Click ID': cut(gid.join(' ')),
      'Other Click IDs': cut(other.join(' ')),
      'Visits Before Order': String(data.visits),
      'First Visit Date': new Date(f.ts).toISOString().slice(0, 10)
    };
  }

  // Write cart attributes once per session per (data, cart). Does not touch items, drawer or totals.
  function cartCookie() { var m = document.cookie.match(/(?:^|;\s*)cart=([^;]+)/); return m ? m[1] : ''; }
  var sending = false;
  function send() {
    if (sending) return;
    var a = attrs(), sig = JSON.stringify(a);
    if (get(ss, KEY + '_sent') === sig + cartCookie()) return;
    sending = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: a }) })
      .then(function (r) { if (r.ok) set(ss, KEY + '_sent', sig + cartCookie()); })
      .catch(function () {})
      .then(function () { sending = false; });
  }
  send();
  ['cart:updated', 'product-ajax:added'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(send, 300); }); });
})();
